import React, { useState } from 'react';

import GetTypeWiseDocuments from '@features/supplier/component/GetTypeWiseDocuments';
import AddAssessmentDocuments from '@features/supplier/component/AddAssessmentDocuments';

import { useSupplierDocuments } from '@store/reducers/supplier-onboarding/OnboardingReducer';

const AssessmentDocuments = () => {
	const documents = useSupplierDocuments();
	const [isAdd, setIsAdd] = useState(false);

	const additionalInformationDocumnetList =
		documents['additionalInformationDocumnetList']?.sort((a, b) => b.id - a.id) || [];

	return (
		<>
			<div className="section-padding hover-section">
				<h3 className="suplier-title pb-4 font-weight-bold regular-16">
					Assessment documents
					<span className="ml-12">
						<button
							className="blue border-0 medium-14 bg-transparent"
							onClick={() => setIsAdd(true)}
						>
							Add
						</button>
					</span>
				</h3>
				<div className="info-items_bottom">
					<GetTypeWiseDocuments
						documents={{ additionalInformationDocumnetList: additionalInformationDocumnetList }}
						title="Assessment Information"
						fieldName="additionalInformationDocumnetList"
					/>
				</div>
			</div>
			{isAdd && <AddAssessmentDocuments documents={documents} onClose={() => setIsAdd(false)} />}
		</>
	);
};

export default AssessmentDocuments;
